<div class="layout-wrapper layout-static" [ngClass]="containerClass">
  <rb-topbar />
  <rb-sidebar />
  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
    <rb-footer />
  </div>
  <div class="layout-mask animate-fadein"></div>
</div>
